import { render } from "./MsNumber.vue?vue&type=template&id=e60cfc5a&scoped=true"
import script from "./MsNumber.vue?vue&type=script&lang=js"
export * from "./MsNumber.vue?vue&type=script&lang=js"

import "./MsNumber.vue?vue&type=style&index=0&id=e60cfc5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60cfc5a"]])

export default __exports__